import { render, staticRenderFns } from "./xgPersonal.vue?vue&type=template&id=71e1164e&scoped=true&"
import script from "./xgPersonal.vue?vue&type=script&lang=js&"
export * from "./xgPersonal.vue?vue&type=script&lang=js&"
import style0 from "./xgPersonal.vue?vue&type=style&index=0&id=71e1164e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e1164e",
  null
  
)

export default component.exports